<template>
  <div class="row">
    <div class="col-md-1"/>
    <div class="col-md-10">

      <h2 style="text-align:center;">
        Rekapitulácia položiek DP typ A za zdaňovacie obdobie 2018
      </h2>

      <h4>
        <strong>
          {{ $route.params.userId }}
        </strong>
      </h4>

      <br>
      <br>

      <report-table-tuz
        :head-labels="tuzLabels"
        :table-data="reports.inland.items"
        :foot-data="reports.inland.sum" />

      <hr>

      <report-table-zah
        :head-labels="zah1Labels"
        :table-data="reports.outland_tax.items"
        :foot-data="reports.outland_tax.sum" />

      <report-table-zah
        :head-labels="zah2Labels"
        :table-data="reports.outland_notax.items"
        :foot-data="reports.outland_notax.sum" />

      <hr>

      <table style="width:100%">
        <tr>
          <td>Základ dane po vyňatí príjmov:</td>
          <td style="text-align:right;">{{ reports.zdMinusUhrnVynPrij }}</td>
        </tr>
        <tr>
          <td>Suma príspevkov o ktoré sa zvyšuje základ dane:</td>
          <td style="text-align:right;">
            {{ reports.zvysenieZd === null ? '0.00' : reports.zvysenieZd }}
          </td>
        </tr>
      </table>

      <hr>

      <table style="width:100%">
        <th>
          Zníženie základu dane
        </th>
        <th style="text-align:right;">
          €
        </th>
        <tr
          v-for="(item, key) in zniZaklDane"
          :key="key"
          class="tr">
          <td
            style="text-align:right;"
            data-col-seq="1">
            {{ item.label }}
          </td>
          <td
            style="text-align:right;"
            data-col-seq="2">
            {{ reports.znizenie[item.sum] === null ? '0.00' : reports.znizenie[item.sum] }}
          </td>
        </tr>
        <tfoot>
          <tr>
            <td style="text-align:right;">Spolu:</td>
            <td style="text-align:right;">{{ reports.znizenie.ncSpolu }}</td>
          </tr>
        </tfoot>
      </table>

      <hr>

      <h3>Daň z príjmov</h3>
      <br>
      <table style="width:100%;">
        <th>Nárok na daňový bonus na vyživované deti</th>
        <th style="text-align:right;">€</th>

        <tr
          v-for="(item, key) in reports.deti.items"
          :key="key"
          class="tr">
          <td data-col-seq="1">
            {{ item.name }}
          </td>
          <td
            style="text-align:right;"
            data-col-seq="2">
            {{ item.bonus === null ? '0.00' : item.bonus }}
          </td>
        </tr>
        <tfoot>
          <tr>
            <td style="text-align:right;">Spolu:</td>
            <td style="text-align:right;">{{ reports.deti.sum.bonus }}</td>
          </tr>
          <tr
            v-for="(item, key) in detiFoot"
            :key="key">

            <td style="text-align:right;">
              <strong>{{ item.label }}</strong>
            </td>

            <td style="text-align:right;">
              {{ reports.deti[item.suma] === null ? '0.00' : reports.deti[item.suma] }}
            </td>
          </tr>
        </tfoot>
      </table>

      <hr>

      <table style="width:100%">
        <tr
          v-for="(item, key) in lastTable"
          :key="key"
          class="tr">

          <td>
            <strong>{{ item.label }}</strong>
          </td>

          <td
            style="text-align:right;">
            {{ reports[item.sum] === null ? '0.00' : reports[item.sum] }}
          </td>
        </tr>
      </table>

    </div>
    <div class="col-md-1"/>
  </div>
</template>

<script>
import restEditor from '@/mixins/restEditor';
import reportTableTuz from './reportTableTuz.vue';
import reportTableZah from './reportTableZah.vue';

function reportData() {
  return {
    inland: {
      items: {
        prijmy_pp: null,
        odvody: null,
        bonus: null,
        dan35: null,
      },
      sum: {
        prijmy_pp: null,
        odvody: null,
        bonus: null,
        dan35: null,
      },
    },
    outland_tax: {
      items: {
        prijmy: null,
        odvody: null,
        zdroj: null,
      },
      sum: {
        prijmy: null,
        odvody: null,
      },
    },
    outland_notax: {
      items: {
        prijmy: null,
        odvody: null,
        zdroj: null,
      },
      sum: {
        prijmy: null,
        odvody: null,
      },
    },
    zdMinusUhrnVynPrij: null,
    zvysenieZd: null,
    znizenie: {
      ncNaDanovnika: null,
      ncNaManzelku: null,
      ncNaDoplnkoveDochodkoveSpor: null,
      ncNaKsDanovnika: null,
      ncNaKsPartner: null,
      ncNaKsDeti: null,
      ncSpolu: null,
    },
    deti: {
      items: {
        name: null,
        bonus: null,
      },
      sum: {
        bonus: null,
      },
      bonusPriznanehoZamest: null,
      bonusNarokMinusPriznany: null,
      narokNaDanovyBonus: null,
    },
    uhrnPreddavkov: null,
    danNaUhradu: null,
    danovyPreplatok: null,
    bonusNaPoukazanieSpravcomDane: null,
    bonusPriznanehoZamest: null,
  };
}

export default {

  mixins: [restEditor],

  components: {
    reportTableTuz,
    reportTableZah,
  },

  data() {
    const id = null;
    const parent = this.$route.params.userId;
    return {
      id,
      parent,
      reports: [reportData()],
      zniZaklDane: {
        1: { label: '-na daňovníka:', sum: 'ncNaDanovnika' },
        2: { label: '-na doplnkové dôchodkové sporenie:', sum: 'ncNaDoplnkoveDochodkoveSpor' },
        3: { label: '-na manželku/manžela:', sum: 'ncNaManzelku' },
        4: { label: '-na kúpeľnú starostlivosť daňovníka:', sum: 'ncNaKsDanovnika' },
        5: { label: '-na kúpeľnú starostlivosť manželky/manžela:', sum: 'ncNaKsPartner' },
        6: { label: '-na kúpeľnú starostlivosť deti:', sum: 'ncNaKsDeti' },
      },
      lastTable: {
        1: { label: 'Úhrn preddavkov na daň:', sum: 'uhrnPreddavkov' },
        2: { label: 'Daň na úhradu:', sum: 'danNaUhradu' },
        3: { label: 'Daňový preplatok:', sum: 'danovyPreplatok' },
        4: { label: 'Daňový bonus na vyživované deti na poukázanie správcom dane:', sum: 'bonusNaPoukazanieSpravcomDane' },
        5: { label: 'Daňový bonus na zaplatené úroky na poukázanie správcom dane:', sum: 'bonusPriznanehoZamest' },
      },
      detiFoot: {
        1: { label: 'Daňový bonus vyplatený zamestnávateľom:', suma: 'bonusPriznanehoZamest' },
        2: { label: 'Rozdiel:', suma: 'bonusNarokMinusPriznany' },
        3: { label: 'Nárok na daňový bonus na zaplatené úroky:', suma: 'narokNaDanovyBonus' },
      },
      tuzLabels: {
        tuz: { label: 'Tuzemské príjmy v €' },
        zdan: { label: 'zdaniteľné príjmy' },
        odv: { label: 'odvody' },
        danBonus: { label: 'daňový bonus' },
        preddavky: { label: 'preddavky na daň' },
      },
      zah1Labels: {
        tuz: { label: 'Zahraničné príjmy v €' },
        zdan: { label: 'príjmy zdanené v zahraničí' },
        odv: { label: 'odvody' },
        danBonus: { label: 'zdroj príjmov' },
      },
      zah2Labels: {
        tuz: { label: 'Zahraničné príjmy v €' },
        zdan: { label: 'príjmy nezdanené v zahraničí' },
        odv: { label: 'odvody' },
        danBonus: { label: 'zdroj príjmov' },
      },
    };
  },

  methods: {
    async processGet() {
      this.reports = await this.restDataSource.listObject(`dpfo/subjects/${this.parent}/report`);
    },
    async processSave() {
      return null;
    },
  },
};
</script>
